/* eslint-disable */
import "../App.css";
import React, { useState, useEffect } from "react";
import {
  collection,
  doc,
  addDoc,
  setDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { UserContext } from "../contexts/User/User";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import { NotificationManager } from "react-notifications";
import { generateBingoCard } from "../utils/Bingo";

const ADMIN_ID = "aVidi38mKdt9tHKPuiA5";

const Login = () => {
  const [login, setLogin] = useState("");
  const [players, setPlayers] = useState([]);
  const [state, dispatch] = React.useContext(UserContext);

  const doLogin = async (e) => {
    e.preventDefault();
    showSuccess("Please wait");
    try {
      //parse player name and check if force login
      const forceLogin = login.startsWith("(FORCE)");
      let playerName = login.replace("(FORCE)", "").replace("rian","rain").trim(); //stitch up brian
      //remove emoji
      playerName = playerName
        .replace(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          ""
        )
        .replace(/\s+/g, " ")
        .trim();

      //check special chars
      const regExp = /[`!@#$%^&*()_+\=\[\]{};:"\\|,.<>\/?~]/;
      if (regExp.test(playerName)) {
        showError("No special characters mate");
        return;
      }

      if (!playerName) {
        showError("Enter a proper name, dog");
        return;
      }
      if (playerName.length > 30) {
        showError("Sorry mate, your name's too long");
        return;
      }

      //get players with the same name for unique check
      const userQuery = query(
        collection(db, "scorecard", state.scorecard, "players"),
        where("lowerName", "==", playerName.toLowerCase())
      );
      const existingPlayers = await getDocs(userQuery);
      let playerId;

      if (existingPlayers.size > 0) {
        if (forceLogin) {
          playerName = existingPlayers.docs[0]?.data()?.name;
          playerId = existingPlayers.docs[0].id;
        } else {
          showError("Name taken, enter another. See Kayla if you are logged out by accident.");
          return;
        }
      } else {
        //handle admin special case:
        if (playerName === "Admin") {
          playerId = ADMIN_ID;
          await setDoc(
            doc(db, "scorecard", state.scorecard, "players", ADMIN_ID),
            {
              name: playerName,
              lowerName: playerName.toLowerCase(),
              golfScore: 0,
              bingoScore: 0,
              holesComplete: 0,
            }
          );
        } else {
          //add player to pub golf scorecard
          const player = await addDoc(
            collection(db, "scorecard", state.scorecard, "players"),
            {
              name: playerName,
              lowerName: playerName.toLowerCase(),
              golfScore: 0,
              bingoScore: 0,
              holesComplete: 0,
            }
          );
          playerId = player.id;
        }

        //generate unique bingo card
        const bingoCard = await generateBingoCard(state.scorecard);
        //add player to pub golf scorecard
        await Promise.all(
          bingoCard.map((bingoChallenge) => {
            setDoc(
              doc(
                db,
                "scorecard",
                state.scorecard,
                "players",
                playerId,
                "bingo",
                bingoChallenge.id
              ),
              bingoChallenge
            );
          })
        );
      }

      localStorage.setItem("name", playerName);
      localStorage.setItem("player_id", playerId);
      localStorage.setItem("game", "kayla");
      dispatch({ name: playerName, id: playerId, game: "kayla" });
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  };

  useEffect(() => {
    const fetchPost = async () => {
      await getDocs(
        collection(db, "scorecard", state.scorecard, "players")
      ).then((querySnapshot) => {
        const newData = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setPlayers(newData);
      });
    };

    fetchPost();
  }, []);

  const showError = (message) => {
    NotificationManager.error(message, null, 3000);
  };

  const showSuccess = (message) => {
    NotificationManager.success(message, null, 3000);
  };

  return (
    <Container>
      <Card className="m15 p15">
        <h1 className="header">Pub Golf</h1>

        <input
          type="text"
          placeholder="Enter ya name, competitor"
          onChange={(e) => setLogin(e.target.value)}
        />
        <p>
          Open this in your browser, <b>not the facebook or messenger app</b>
        </p>
        <p>If you get logged out, see Kayla</p>

        <Button variant="success" onClick={doLogin} className="m15">
          Cheers!
        </Button>
      </Card>
      <Card className="m15 simple-table">
        <Table bordered striped hover>
          <thead>
            <th>
              <td>Competitors</td>
            </th>
          </thead>
          <tbody>
            {players?.map((player, i) => {
              if (player.id === ADMIN_ID || !player.name) {
                return;
              }
              return (
                <tr key={i}>
                  <td>{player.name}{player.official && " (Official)"}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card>
    </Container>
  );
};

export default Login;
